import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconMoneyBanknoteHand = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24h-24v-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M6 21h-2c-.552 0-1-.448-1-1v-6c0-.552.448-1 1-1h2c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M13 17h2.333c.433 0 .854-.14 1.2-.4l2.416-1.812c.603-.452 1.447-.392 1.98.141v0c.592.592.592 1.551 0 2.142l-2.073 2.073c-.558.558-1.27.939-2.044 1.094l-2.93.586c-.581.116-1.18.102-1.755-.042l-2.65-.662c-.317-.08-.642-.12-.969-.12h-1.508"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M13 17h1.485c.837 0 1.515-.678 1.515-1.515v-.303c0-.695-.473-1.301-1.147-1.469l-2.292-.573c-.373-.093-.755-.14-1.139-.14v0c-.927 0-1.834.274-2.605.789l-1.817 1.211"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M10.667 10h8.667c.92 0 1.666-.746 1.666-1.667v-4.666c0-.921-.746-1.667-1.667-1.667h-8.667c-.92 0-1.666.746-1.666 1.667v4.667c0 .92.746 1.666 1.667 1.666Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M16.061 4.939c.586.586.586 1.537 0 2.122 -.586.585-1.537.586-2.122 0 -.586-.586-.586-1.537 0-2.122 .586-.585 1.536-.585 2.122 0"
  })));
};
//# sourceMappingURL=IconMoneyBanknoteHand.js.map